<template>
  <div :class="{'container-dark': theme_dark}">
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">通知/音效设置</div>
      <div class="nav-right">
        <span class="nav-lable"></span>
        <img src="../../assets/img/返回箭头.png" class="nav-img none" />
      </div>
    </div>


    <div class="item">
      <span>系统音效设置</span>
    </div>

  <ul class="menu-block">
      <li class="ub ub-pc menu-item">
            <div class="ub-ae ub-f1 menu-item-name">匹配音效</div>
            <label class="switch">
              <input type="checkbox" v-model="msg_vol_1" @change="change('msg_vol_1')" />
              <div class="slider round"></div>
            </label>
      </li>
           <div class="menu-line"></div>

      <li class="ub ub-pc menu-item">
            <div class="ub-ae ub-f1 menu-item-name">消息音效</div>
            <label class="switch">
              <input type="checkbox" v-model="msg_vol_2" @change="change('msg_vol_2')" />
              <div class="slider round"></div>
            </label>
      </li>
      <div class="menu-line"></div>
  </ul>

    <div class="item">
    <span>微信公众号通知设置</span>
  </div>

    <ul class="menu-block">

       <li class="ub ub-pc menu-item">
            <div class="ub-ae ub-f1 menu-item-name">购买成功通知</div>
            <label class="switch">
              <input type="checkbox" v-model="msg_wx_buy" @change="change('msg_wx_buy')"/>
              <div class="slider round"></div>
            </label>
          </li>

          <div class="menu-line"></div>

          <li class="ub ub-pc menu-item">
            <div class="ub-ae ub-f1 menu-item-name">签到成功通知</div>
            <label class="switch">
              <input type="checkbox" v-model="msg_wx_sign" @change="change('msg_wx_sign')"/>
              <div class="slider round"></div>
            </label>
          </li>


        <div v-if="false">
          <div class="menu-line"></div>

          <li class="ub ub-pc menu-item">
            <div class="ub-ae ub-f1 menu-item-name">离线消息通知</div>
            <label class="switch">
              <input type="checkbox" v-model="msg_wx_msgoff" @change="change('msg_wx_msgoff')"/>
              <div class="slider round"></div>
            </label>
          </li>

          <div class="menu-line"></div>

           <li class="ub ub-pc menu-item">
            <div class="ub-ae ub-f1 menu-item-name">离线礼物通知</div>
            <label class="switch">
              <input type="checkbox" v-model="msg_wx_gift" @change="change('msg_wx_gift')"/>
              <div class="slider round"></div>
            </label>
          </li>

           <div class="menu-line"></div>

          <li class="ub ub-pc menu-item">
            <div class="ub-ae ub-f1 menu-item-name">上榜奖励通知</div>
            <label class="switch">
              <input type="checkbox" v-model="msg_wx_rank" @change="change('msg_wx_rank')" />
              <div class="slider round"></div>
            </label>
          </li>

           <div class="menu-line"></div>

          <li class="ub ub-pc menu-item">
            <div class="ub-ae ub-f1 menu-item-name">提现到账通知</div>
            <label class="switch">
              <input type="checkbox" v-model="msg_wx_tx" @change="change('msg_wx_tx')"/>
              <div class="slider round"></div>
            </label>
          </li>
          <div class="menu-line"></div>

          <li class="ub ub-pc menu-item">
            <div class="ub-ae ub-f1 menu-item-name">收益发放通知</div>
            <label class="switch">
              <input type="checkbox" v-model="msg_wx_pstu" @change="change('msg_wx_pstu')"/>
              <div class="slider round"></div>
            </label>
          </li>
           <div class="menu-line"></div>

           <li class="ub ub-pc menu-item">
            <div class="ub-ae ub-f1 menu-item-name">返还金币通知</div>
            <label class="switch">
              <input type="checkbox" v-model="msg_wx_backcoin" @change="change('msg_wx_backcoin')"/>
              <div class="slider round"></div>
            </label>
          </li>
          </div>
        </ul>



  </div>
</template>

<script>
import * as tool from "../../api/common";
import { mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
       msg_vol_1:false,
       msg_vol_2:false,
       msg_wx_rank:false,
       msg_wx_gift:false,
       msg_wx_buy:false,
       msg_wx_tx:false,
       msg_wx_sign:false,
       msg_wx_pstu:false,
       msg_wx_msgoff:false,
       msg_wx_backcoin:false,

       theme_dark: false
    };
  },
  mounted() {
    //切换深色模式
    this.theme_dark = tool.is_theme_dark(this);
    this.init_page();
  },
  methods: {
    ...mapMutations(["get", "post"]), //引入方法
     back() {
      this.$router.go(-1); //返回上一层
    },
    init_page() {
      var uid = this.$store.state.uid;
      var self = this;
      self.get({
        url: "/App/GetSettingData?uid=" + uid,
        success: function (data) {
        //console.log(JSON.stringify(data));
         self.msg_vol_1=data.msg_vol_1 == 1 ? true : false;
         self.msg_vol_2=data.msg_vol_2 == 1 ? true : false;
         self.msg_wx_rank=data.msg_wx_rank == 1 ? true : false;
         self.msg_wx_gift=data.msg_wx_gift == 1 ? true : false;
         self.msg_wx_buy=data.msg_wx_buy == 1 ? true : false;
         self.msg_wx_tx=data.msg_wx_tx == 1 ? true : false;
         self.msg_wx_sign=data.msg_wx_sign == 1 ? true : false;
         self.msg_wx_pstu=data.msg_wx_pstu == 1 ? true : false;
         self.msg_wx_msgoff=data.msg_wx_msgoff == 1 ? true : false;
         self.msg_wx_backcoin=data.msg_wx_backcoin == 1 ? true : false;
         //更新全局数据
         self.$store.commit('set_objVal', {"setting":data});
        },
      });
    },

    change(txt){
        //匹配音效设置
        if(txt=='msg_vol_1'){

          this.dosave(txt,this.msg_vol_1?1:0);
        }
         //收消息音效设置
        if(txt=='msg_vol_2'){

          this.dosave(txt,this.msg_vol_2?1:0);
        }
        //上榜奖励通知
        if(txt=='msg_wx_rank'){

          this.dosave(txt,this.msg_wx_rank?1:0);
        }
        //离线礼物通知
        if(txt=='msg_wx_gift'){

          this.dosave(txt,this.msg_wx_gift?1:0);
        }
        //购买成功通知
        if(txt=='msg_wx_buy'){

          this.dosave(txt,this.msg_wx_buy?1:0);
        }
        //提现到账通知
        if(txt=='msg_wx_tx'){

          this.dosave(txt,this.msg_wx_tx?1:0);
        }
        //签到成功通知
        if(txt=='msg_wx_sign'){

          this.dosave(txt,this.msg_wx_sign?1:0);
        }
        //收益发放通知
        if(txt=='msg_wx_pstu'){

          this.dosave(txt,this.msg_wx_pstu?1:0);
        }
        //离线消息通知
        if(txt=='msg_wx_msgoff'){

          this.dosave(txt,this.msg_wx_msgoff?1:0);
        }
        //返还金币通知
        if(txt=='msg_wx_backcoin'){

          this.dosave(txt,this.msg_wx_backcoin?1:0);
        }
    },
    dosave(txt,val){
      var uid = this.$store.state.uid;
      var self = this;
      self.get({
        url: "/App/SetSetting?uid=" + uid+"&key="+txt+"&val="+val,
        success: function (data) {
        //console.log(JSON.stringify(data));
        if (data.state == "1") {
               //设置成功
               if(val==1){
                self.$toast.top("已开启");
               }else{
                 self.$toast.top("已关闭");
               }

              self.init_page();
            }
        },
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.item{
  padding: 1.5rem 0 .5rem .8rem;
  font-size: .85rem;
  background-color:#ededed;
  color:#8a8a8a;
}
.menu-block {
  padding: 0 1.2rem 0 .8rem;
  background-color: #fff;
  .menu-item {
    height: 3rem;
    .menu-item-name{
      font-size: .95rem;
    }
    .switch {
      position: relative;
      display: inline-block;
      width: 3.2rem;
      height: 1.8rem;
      input {
        display: none;
        outline: 0;
      }
      .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 3.5rem;
        height: 1.8rem;
        background-color: #fdfdfd;
        transition: 0.1s;
        border: 2px solid #dcdcdc;
        user-select: none;
        border-radius: 1.1rem;
        outline-style: none;
        border: 1px solid #ddd;
        text-shadow: none;
        -webkit-appearance: none;
        -webkit-user-select: text;
        -webkit-tap-highlight-color:rgba(0,0,0,0);

      }
      .slider:before {
        position: absolute;
        content: "";
        height: 1.8rem;
        width: 1.8rem;
        background-color: white;
        transition: 0.1s;
        box-shadow: 0px 0.1px 2px #EEEEEE;
        border-radius: 50%;
      }
      input:checked + .slider {
        background-color: #45db5e;
      }
      input:checked + .slider:before {
        transform: translateX(1.7em);
      }
    }
  }
  .menu-line {
    border-top: 1px solid #EFEFEF;
  }
}

.container-dark {
  min-height: 100vh;
  background-color: #2f2e33;
  .item{
    background-color:#2f2e33;
    color:#8a8a8a;
  }
  .menu-block {
    background-color: #2c2b30;
    .menu-item {
      .menu-item-name{
        color: #DFDFDF;
      }
    }
    
  }
  .menu-line {
    border-top: 1px solid #404040;
  }
}
</style>
